import Global from "@/components/Global";
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";


export const MessageInputHandler = {
  MyFunction: function(param) {
    alert(param);
  },

  submitMessage: function(value, quotedMessageId) {
    var url = webTypeApiUrl.MessageAPI + "/Chat/SendMessageByRoom";
    //發送訊息
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        roomId: Global.current_roomid,
        staffId: Global.current_staffid,
        message: value,
        msgtime: new Date().toISOString(),
        quotedMessageId: quotedMessageId || null
      },
      dataType: "json",
      success: function(data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        }
      },
      error: function(a, b, c) {}
    });
  }
};



// WEBPACK FOOTER //
// ./src/handler/MessageInputHandler.js